import React, { createContext, useContext } from 'react';

import type { ThemePreference } from '@/utils/useDarkMode.tsx';

interface ApplicationContextValue {
    themePreference: ThemePreference;
    setThemePreference: (preference: ThemePreference) => void;
    isDarkMode: boolean;
}

interface ApplicationContextProviderProps extends ApplicationContextValue {
    children: React.ReactNode;
}

const ApplicationContext = createContext<ApplicationContextValue>({
    themePreference: 'light',
    setThemePreference: () => {},
    isDarkMode: false,
});

const ApplicationContextProvider = ({ children, ...value }: ApplicationContextProviderProps) => (
    <ApplicationContext.Provider value={value}>{children}</ApplicationContext.Provider>
);

export const useApplicationContext = () => useContext(ApplicationContext);

export default ApplicationContextProvider;
